import MenuEllipsis from './MenuEllipsis';

export default MenuEllipsis;
